import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@atlaskit/primitives';
import { ReactRenderer } from '@atlaskit/renderer';
import { fontFallback } from '@atlaskit/theme/typography';
import { guidelineMaxLength, nameMaxLength } from '../../constants';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Name = styled.h2({
  font: `var(--ds-font-heading-medium, ${fontFallback.heading.medium})`,
  color: "var(--ds-text, #172B4D)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Guideline = styled.p({
  font: `var(--ds-font-body, ${fontFallback.body.medium})`,
  color: "var(--ds-text, #172B4D)",
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word'
});
export const ClassificationView = ({
  name,
  guideline,
  guidelineRepresentation = 'PLAIN'
}) => {
  const nameTruncated = (name !== null && name !== void 0 ? name : '').substring(0, nameMaxLength);
  const guidelineTruncated = (guideline !== null && guideline !== void 0 ? guideline : '').substring(0, guidelineMaxLength);
  return /*#__PURE__*/React.createElement(Box, null, nameTruncated && /*#__PURE__*/React.createElement(Name, {
    id: "data-classification-read-content-name"
  }, nameTruncated), guideline && /*#__PURE__*/React.createElement(Box, {
    paddingBlockStart: "space.200"
  }, guidelineRepresentation === 'PLAIN' ? /*#__PURE__*/React.createElement(Guideline, {
    id: "data-classification-read-content-guideline"
  }, guidelineTruncated) : /*#__PURE__*/React.createElement(ReactRenderer, {
    maxHeight: 200,
    truncated: true,
    document: JSON.parse(guideline)
  })));
};